<div class="container">
    <h1>404</h1>
    <p>{{"404.pageNotFound" | translate}}</p>
</div>

